module.exports = __webpack_public_path__ + "img/fisrt_bg.f03651fa.png";